import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import RootNavigation from "./navigation/RootNavigation";
import { Auth0Provider } from "@auth0/auth0-react";

import {
  AUTH_CLIENTID,
  AUTH_DOMAIN,
  AUTH_FREECLIENTID,
} from "./service/common/const";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={AUTH_DOMAIN}
      // clientId={
      //   window.location.pathname.includes("free")
      //     ? AUTH_FREECLIENTID
      //     : AUTH_CLIENTID
      // }
      clientId={AUTH_CLIENTID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://dev-1d44y6ps8vbgsnlq.eu.auth0.com/api/v2/",
        // scope: "openid email profile",
        scope:
          "openid email profile read:current_user update:current_user_metadata",
      }}
    >
      <RootNavigation />
    </Auth0Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
